import BaseService from '../BaseService.js'

export default class ModuleService extends BaseService {
  constructor() {
    super('module')
  }
}
